import { render } from "./CheckCode.vue?vue&type=template&id=72c57957"
import script from "./CheckCode.vue?vue&type=script&lang=js"
export * from "./CheckCode.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__